var _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgLocation2(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 19,
    height: 20,
    viewBox: "0 0 19 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M9.50001 2.0835C6.43626 2.0835 3.95834 4.56141 3.95834 7.62516C3.95834 11.7814 9.50001 17.9168 9.50001 17.9168C9.50001 17.9168 15.0417 11.7814 15.0417 7.62516C15.0417 4.56141 12.5638 2.0835 9.50001 2.0835ZM5.54168 7.62516C5.54168 5.44016 7.31501 3.66683 9.50001 3.66683C11.685 3.66683 13.4583 5.44016 13.4583 7.62516C13.4583 9.90516 11.1783 13.3172 9.50001 15.4468C7.85334 13.3331 5.54168 9.88141 5.54168 7.62516Z",
    fill: "white"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M9.50001 9.60433C10.5931 9.60433 11.4792 8.71823 11.4792 7.62516C11.4792 6.5321 10.5931 5.646 9.50001 5.646C8.40695 5.646 7.52084 6.5321 7.52084 7.62516C7.52084 8.71823 8.40695 9.60433 9.50001 9.60433Z",
    fill: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLocation2);
export default __webpack_public_path__ + "static/media/location2.23bd4f1be7c937cd814f3ef12350953d.svg";
export { ForwardRef as ReactComponent };